import { ConsultationNode, ConsultationSection } from '../config';

const formatSection = (section: ConsultationSection): string => {
  const sectionContent = section.content
    .map((contentItem) => contentItem.text.trim())
    .filter(Boolean)
    .join('\n');

  return sectionContent ? `${section.title}:\n${sectionContent}` : '';
};

const formatNode = ({ children, title }: ConsultationNode): string => {
  const formattedSections = children
    .map(formatSection)
    .filter(Boolean)
    .join('\n\n');

  if (!formattedSections) {
    return '';
  }

  return title ? `${title}:\n\n${formattedSections}` : formattedSections;
};

export const formatConsultationCopyText = (nodes: ConsultationNode[]): string =>
  nodes.map(formatNode).filter(Boolean).join('\n\n\n');
